import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { Header } from "./components/header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { GeneratePatrimonioCentroCustoColumnsDefinition } from "./columns";
import { usePatrimonioCentroCustoListaViewModel } from "../../viewModels/patrimonio_maquina_equip_view_model";
import { PatrimonioCentroCustoModal } from "./components/checklist_maquina_equip_modal";
import { PatrimonioCentroCustoListaModel } from "../../../domain/models/patrimonio_centro_custo_lista";

/**
 * PatrimonioCentroCustoLista
 */

export const PatrimonioCentroCustoLista = () => {
  const viewModel = usePatrimonioCentroCustoListaViewModel();

  const columnsDefinition = useMemo(() => {
    return GeneratePatrimonioCentroCustoColumnsDefinition({
      onActionEditar: viewModel.handlePatrimonioCentroCustoModal,
      onActionDeletar: viewModel.handlePatrimonioCentroCustoDeleteModal,
      onEnterChecklists: viewModel.handleEnterChecklist,
    });
  }, [
    viewModel.handlePatrimonioCentroCustoModal,
    viewModel.handlePatrimonioCentroCustoDeleteModal,
    viewModel.handleEnterChecklist,
  ]);

  // const pinnedColumns = useMemo((): GridPinnedColumnFields | undefined => {
  //   return viewModel.checklist && viewModel.checklistServicos.length > 0
  //     ? { right: ['idPatrimonioCentroCusto', 'copiar'] }
  //     : undefined;
  // }, [
  //   viewModel.checklist,
  //   viewModel.checklistServicos,
  // ]);

  return (
    <>
      {/**
        * PageTopBar
        */}

      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">

              <div className="w-[115px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onMouseDown={e => viewModel.handlePatrimonioCentroCustoModal(null, true)}>
                  Novo Item
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Typography className="text-primary-green">
            Gestão de Máquina/equipamento
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Gestão de Máquina/equipamento</h1>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>

          <div className="w-full justify-end flex gap-2"></div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Header
                  status={viewModel.filters.status}
                  onStatusChange={viewModel.handleStatusChange}
                  centroCustos={viewModel.filters.idsCentroCusto}
                  centroCustoDropdown={viewModel.ddlCentroCusto}
                  onCentroCustoChange={viewModel.handleIdsCentroCustoChange}
                  onClearFilters={viewModel.handleClearFilters}
                />

                <Stack spacing={0}>
                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />

                  <StyledDataGrid
                    tableName="checklist_servico_lista"
                    disableColumnMenu={false}
                    getRowId={(row: PatrimonioCentroCustoListaModel) => row.idPatrimonioCentroCusto}
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    rows={viewModel.patrimonioCentroCustos}
                    rowCount={viewModel.patrimonioCentroCustos.length}
                    pinnedColumns={viewModel.patrimonioCentroCustos.length > 0 ? { right: ['idPatrimonioCentroCusto', 'copiar'] } : undefined}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                    sx={{
                      '& .ia-header': {
                        backgroundColor: "#26C281",
                      }
                    }}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />
                </Stack>
              </>
            )
        }
      </div>

      {/**
        * Modals
        */}

      <PatrimonioCentroCustoModal
        open={viewModel.patrimonioCentroCustoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedPatrimonioCentroCusto={viewModel.selectedPatrimonioCentroCusto ?? null}
        onClose={viewModel.handlePatrimonioCentroCustoModal}
        onSubmit={viewModel.handlePatrimonioCentroCustoSubmit}
      />

      {/* <CopyChecklistServicoModal
          open={viewModel.copyChecklistServicoModal}
          saving={viewModel.saving}
          loading={viewModel.loading}
          selectedChecklistServico={viewModel.selectedChecklistServico ?? null}
          onClose={viewModel.handleCopyChecklistServicoModal}
          onSubmit={viewModel.handleCopyChecklistServicoSubmit}
        /> */}

      <DeleteDialog
        open={viewModel.patrimonioCentroCustoDeleteModal}
        saving={viewModel.saving}
        title='Você realmente deseja excluir este item?'
        onClose={() => viewModel.handlePatrimonioCentroCustoDeleteModal(null, false)}
        onDelete={viewModel.handlePatrimonioCentroCustoDeleteSubmit}
      />

      {/* <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      /> */}

    </>
  );
}